// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1zJ0F","content":"Consent_content__dvLiy","footer":"Consent_footer__27Ky0"};